import React from "react";
import { connect } from "react-redux";
import * as actions from "../../actions/actions";

import SignupPageLayout from "./signup/signup-page-layout";
import LoginPageLayout from "./login/login-page-layout";
import LoginForm from "./login/login-form";
import SignupForm from "./signup/signup-form";
import AccountFeatures from "./signup/rotating-icons";

class AuthModal extends React.Component {
    state = {
        showLogin: false
    };

    getForm = () => {
        return this.state.showLogin ? (
            <LoginPageLayout
                formSectionContent={
                    <LoginForm
                        showSignup={this.showSignup}
                        showFacebookLoginLink
                        onSuccess={this.handleSuccess}
                    />
                }
            />
        ) : (
            <div>
                <SignupPageLayout
                    featuresSectionContent={
                        <AccountFeatures signupType="pro" />
                    }
                    formSectionContent={
                        <SignupForm
                            showLogin={this.showLogin}
                            onSuccess={this.handleSuccess}
                            accentColor="green"
                        />
                    }
                />
            </div>
        );
    };

    handleSuccess = () => {
        this.props.getCurrentUserPromise().then(this.props.dismissModal());
    };

    showSignup = () => {
        this.setState({ showLogin: false });
    };

    showLogin = () => {
        this.setState({ showLogin: true });
    };

    getPageviewUrl() {
        let url;
        if (this.state.showLogin) {
            url = "/accounts/login/";
        } else {
            url = "/accounts/signup/";
        }

        return url;
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.showLogin != this.state.showLogin) {
            let url = this.getPageviewUrl();
            this.props.pageview(url);
        }
    }
    componentDidMount() {
        let url = this.getPageviewUrl();
        this.props.pageview(url);
    }

    render() {
        return <section>{this.getForm()}</section>;
    }
}

AuthModal = connect(null, {
    downloadRequest: actions.downloadRequest,
    getCurrentUserPromise: actions.getCurrentUserPromise,
    pageview: actions.pageview
})(AuthModal);

export default AuthModal;
